import { FC } from "react";

import { colors } from "consts";

import { IconProps } from "../props";

const CloseIcon: FC<IconProps> = ({
  width = 24,
  height = 24,
  className,
  color,
}) => (
  <svg
    width={width}
    height={height}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      transform={`scale(${width / 24})`}
      d="M17.734 6.275a.907.907 0 0 0-1.284 0L12 10.717l-4.45-4.45a.906.906 0 1 0-1.284 1.282L10.716 12l-4.45 4.45a.906.906 0 1 0 1.283 1.284L12 13.284l4.45 4.45a.906.906 0 1 0 1.284-1.284L13.284 12l4.45-4.45a.912.912 0 0 0 0-1.275Z"
      fill={color || colors.dark}
      fillOpacity={0.6}
    />
  </svg>
);

export default CloseIcon;
